import { formatExistingPostToBE } from './formatExistingPostToBE'
import { formatCarouselItemsToBE } from './formatCarouselItemsToBE'
import { formatStoriesItemsToBE } from './formatStoriesItemsToBE'
import { formatSingleImageOrVideoToBE } from './formatSingleImageOrVideoToBE'

import {
  CAROUSEL_ITEMS,
  FORMAT_CAROUSEL,
  FORMAT_EXISTING_POST,
  FORMAT_OPTION,
  FORMAT_SINGLE,
  FORMAT_STORY
} from '../../../../fields'

import { formatAdCreativeToBEParams, FormattedAdCreative } from './types'
import { ExistingPostValues } from './formatExistingPostToBE/types'
import { StoriesItemsValues } from './formatStoriesItemsToBE/types'
import { SingleImageOrVideoValues } from './formatSingleImageOrVideoToBE/types'

export const formatAdCreativeToBE = ({
  values,
  tags,
  selectedAdAccountId,
  lineItem
}: formatAdCreativeToBEParams): FormattedAdCreative => {
  const { [FORMAT_OPTION]: formatOption, [CAROUSEL_ITEMS]: carouselItems } = values

  switch (formatOption) {
    case FORMAT_EXISTING_POST:
      return formatExistingPostToBE({ values: values as ExistingPostValues, tags })
    case FORMAT_CAROUSEL:
      return formatCarouselItemsToBE({ values, items: carouselItems || [], tags })
    case FORMAT_STORY:
      return formatStoriesItemsToBE({ values: values as StoriesItemsValues, tags })
    case FORMAT_SINGLE:
    default:
      return formatSingleImageOrVideoToBE({
        values: values as SingleImageOrVideoValues,
        tags,
        selectedAdAccountId,
        lineItem
      })
  }
}
